import { InformationBoxOutlineIcon } from './InformationBoxOutlineIcon';

/**
 * author: Jeff Anders
 * id AAB1D0C8-033F-4C5F-8ACD-6620947D9858
 * name information-box-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-box-outline.svg
 * tags
 * - Settings 
 */
export const InfoBoxOutlineIcon = InformationBoxOutlineIcon;
export default InfoBoxOutlineIcon